class SfFaq extends HTMLElement {
  connectedCallback() {
    this._onToggle = this.#handleToggle.bind(this);
    this.querySelectorAll('.sf-faq__item-header').forEach((btn) => {
      btn.addEventListener('click', this._onToggle);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('.sf-faq__item-header').forEach((btn) => {
      btn.removeEventListener('click', this._onToggle);
    });
  }

  #handleToggle(event) {
    const button = /** @type {HTMLButtonElement} */ (event.currentTarget);
    const item = button.closest('.sf-faq__item');
    if (!item) return;

    const isOpen = item.classList.contains('sf-faq__item--open');

    // Close all open items
    this.querySelectorAll('.sf-faq__item--open').forEach((openItem) => {
      openItem.classList.remove('sf-faq__item--open');
      openItem.querySelector('.sf-faq__item-header')?.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add('sf-faq__item--open');
      button.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('sf-faq')) {
  customElements.define('sf-faq', SfFaq);
}
